import { css } from "@emotion/react";

import * as dimensions from "@styles/emotion-styles/dimensions";

export const main = css`
  display: flex;
  flex-direction: column;
  max-width: 50rem;
  margin: auto;
  width: 100%;

  @media (min-width: ${dimensions.tablet}) {
    width: 80%;
  }
`;
